<template>
  <b-modal
    :id="id"
    dialog-class="notice-modal"
    scrollable
    hide-header
    hide-header-close
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    centered
  >
    <section id="notice-modal-contents">
      <template v-if="data.length > 0">
        <Flicking
          :options="{
            circular: data.length > 1 ? true : false,
            bounce: data.length > 1 ? '20%' : 0,
            moveType: 'strict',
          }"
          :plugins="plugins"
        >
          <div class="notice-content" v-for="(el, i) in data" :key="i" :class="el.category">
            <template v-if="el.category !== 'img'">
              <article id="headdress"></article>
              <div class="content-wrapper" :class="el.category">
                <div class="title">{{ el.title }}</div>

                <div v-if="isPeriod(el.period)" class="modal-period">{{ period(el.period) }}</div>

                <div class="modal-content">{{ el.content.trim().replaceAll('\\n', '\n') }}</div>

                <div class="modal-imgs" v-if="el.img !== null">
                  <img :class="imgPosition(i, el.img.length)" :src="img" v-for="(img, i) in el.img" :key="i" />
                </div>
              </div>

              <div class="modal-link-wrapper" v-if="el.buttonText !== null">
                <button class="modal-link" @click="openURL(el.isExternalUrl, el.url)">
                  {{ el.buttonText }}
                </button>
              </div>
            </template>

            <img v-else class="cursor-pointer w-100" @click="openURL(el.isExternalUrl, el.url)" :src="`${el.img}`" />
          </div>
          <div slot="viewport" class="flicking-pagination"></div>
        </Flicking>
      </template>
    </section>

    <section class="btn-wrapper">
      <label v-if="noMore" class="modal-btn">
        <input type="checkbox" v-model="noMoreCheck" />
        <article class="btn-content">
          <span></span>
          {{ $t('modal.notice.week') }}
        </article>
      </label>
      <div v-else class="w-100"></div>
      <button class="modal-btn" @click="close">
        <article class="btn-content">
          <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
            <path d="M4.5 4L12.5001 12.0001" stroke="#666666" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12.5 4L4.49993 12.0001" stroke="#666666" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          {{ $t('modal.close') }}
        </article>
      </button>
    </section>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex';

import { Flicking } from '@egjs/vue-flicking';
import { AutoPlay, Pagination } from '@egjs/flicking-plugins';

import Cookies from 'js-cookie';

/** yy.mm.dd */
const formatSet = {
  year: '2-digit',
  month: '2-digit',
  day: '2-digit',
};

export default {
  name: 'BaseModal',
  components: {
    Flicking,
  },
  props: {
    id: {
      type: String,
    },
    noMore: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      noMoreCheck: false,
    };
  },
  computed: {
    ...mapState(['isMobile']),
    ...mapState('MainNoticeStore', ['noticeData', 'urgentData']),
    data() {
      return this.noMore ? this.noticeData : this.urgentData;
    },
    plugins() {
      return this.data.length > 1
        ? [new AutoPlay({ duration: 5000, direction: 'NEXT', stopOnHover: false }), new Pagination({ type: 'bullet' })]
        : [];
    },
  },
  created() {},
  methods: {
    imgPosition(num, len) {
      if (len === 3) {
        return num === 0 ? 'left' : num === 2 ? 'right' : '';
      } else if (len === 2) {
        return num === 0 ? 'first' : 'second';
      } else {
        return '';
      }
    },
    isPeriod(period) {
      return period && (period.start !== null || period.end !== null);
    },
    period(period) {
      window.dt = this.$DateTime;
      const { start, end } = period;

      const DateTime = this.$DateTime;
      /** set str to DateTime */
      const date = (date) => DateTime.fromISO(date, { zone: 'Asia/seoul' }).setLocale('ko');
      /** The date doesn't have time? */
      const nt = (dt) => dt.split('T')[1].split('.')[0] === '00:00:00';
      /** format date: yy.mm.dd HH:mm or yy.mm.dd */
      const fd = (dt) => (nt(dt) ? simpleF(date(dt)) : fullF(date(dt)));
      /** simple format: yy.mm.dd */
      const simpleF = (date) => date.toLocaleString(formatSet).replaceAll('. ', '.');
      /** time format: HH:mm */
      const timeF = (date) => date.toFormat('HH:mm');
      /** day of week: (목) */
      const DoW = (date) => date.toFormat('ccc');
      /** full format: yy.mm.dd HH:mm */
      const fullF = (date) => `${simpleF(date)} ${timeF(date)}`;

      const isSameDay = (start, end) =>
        start === null || end === null
          ? false
          : date(start).hasSame(date(end), 'year') &&
            date(start).hasSame(date(end), 'month') &&
            date(start).hasSame(date(end), 'day');

      const sameDayResult = (start, end) => {
        const dt = simpleF(date(start));
        const dow = DoW(date(start));
        const time = (dt) => (nt(dt) ? '' : timeF(date(dt)));
        return `${dt} (${dow}) ${time(start)} ~ ${time(end)}`;
      };

      const notSameDayResult = (start, end) => {
        const formatStart = start === null ? '' : fd(start);
        const formatEnd = end === null ? '' : fd(end);
        return `${formatStart} ~ ${formatEnd}`;
      };

      return isSameDay(start, end) ? sameDayResult(start, end) : notSameDayResult(start, end);
    },
    openURL(isExLink, url) {
      if (url) {
        isExLink ? window.open(url) : this.$router.push(url);
      }
      this.close();
    },
    async closeWithNoMore() {
      const DateTime = this.$DateTime;

      // 7일 동안 공지 안보기
      const noticeCookie = Cookies.get('notice');
      if (noticeCookie) Cookies.remove('notice');

      // 7일 계산
      const now = DateTime.now();
      // 00:00:00 기준으로 7일 후
      const nextWeek = now.startOf('day').plus({ days: 7 });

      Cookies.set('notice', now.startOf('day').toISO(), { expires: nextWeek.toJSDate() });

      return;
    },
    async close() {
      if (this.noMoreCheck) await this.closeWithNoMore();
      // this.$emit('close', this.id);
      this.$bvModal.hide(this.id);
    },
  },
};
</script>

<style lang="scss">
.modal-dialog.notice-modal {
  // max-width: 454px;
  max-width: 380px;
  margin: 0 auto;
  line-height: 1.2;
  color: #333333 !important;
  transition: $transition;

  @media screen and (max-width: 400px) {
    // max-width: calc(100% - 20px);
    // margin: 0 10px;
    max-width: 275px;
  }

  .flicking-pagination {
    bottom: 9px;
  }

  .flicking-pagination-bullet {
    transition: $transition;
    background-color: #e0e0e0;
    margin: 0 2px;
    width: 6px;
    height: 6px;
  }
  .flicking-pagination-bullet-active {
    background-color: #d0d0d0;
    width: 20px;
    border-radius: 20px;
  }

  .modal-content {
    border-radius: 5px;
    overflow: hidden;
    line-height: 1.5;

    .modal-body {
      padding: 0;
    }
  }
}
</style>

<style lang="scss" scoped>
#notice-modal-contents {
  ::v-deep .flicking-camera {
    align-items: center;
  }

  .notice-content {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    padding: 40px 21px 25px 21px;
    overflow: hidden;
    aspect-ratio: 3/4;

    @media screen and (max-width: 400px) {
      padding: 30px 15px 25px 15px;
      // height: unset;
    }

    &.img {
      padding: 0;
      cursor: pointer;
    }

    #headdress {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: calc(100% - 40px);
      height: 12px;
      border-radius: 0px 0px 100px 100px;
      background: #0f4b9a;

      @media screen and (max-width: 400px) {
        width: calc(100% - 20px);
      }
    }

    .content-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 20px;
      text-align: center;

      @media screen and (max-width: 400px) {
        gap: 10px;
      }

      &.only-text {
        gap: 10px;
        text-align: left;

        .title {
          width: 100%;
        }

        .modal-content {
          line-height: 1.4;
        }
      }

      .title {
        color: #333333;
        text-align: inherit;
        font-size: clamp(1.1rem, 2vw, 1.5rem);
        font-weight: 600;
        letter-spacing: -1.2px;
        line-height: 1;
      }

      .modal-period {
        margin: auto 0 auto;
        width: fit-content;
        padding: 10px 16px;
        line-height: 1;
        border-radius: 100px;
        background: #eef4fa;
        color: #333333;
        text-align: inherit;
        font-size: 16px;
        font-weight: 400;

        @media screen and (max-width: 400px) {
          padding: 8px 12px;
          font-size: 13px;
        }
      }

      .modal-content {
        margin-top: 10px;
        padding: 0px;
        text-align: inherit;
        font-weight: 400;
        font-size: 18px;
        white-space: pre-line;
        transition: $transition;

        @media screen and (max-width: 400px) {
          margin-top: 0px;
          font-size: 13.2px;
        }
      }

      .modal-imgs {
        display: flex;
        margin-top: 24px;
        width: 100%;
        height: 6.5rem;
        justify-content: space-around;
        transition: $transition;

        @media screen and (max-width: 400px) {
          margin-top: 12px;
          height: 4.6rem;
          gap: 6px;
        }

        img {
          height: 100%;
          aspect-ratio: 1 / 1;
          transition: $transition;
          transform-origin: bottom;

          &.first {
            transform-origin: 20% 100%;
          }
          &.second {
            transform-origin: 80% 100%;
          }
          &.left {
            transform-origin: bottom left;
          }
          &.right {
            transform-origin: bottom right;
          }

          &:hover {
            transform: translateX();
            scale: 300%;
          }
        }
      }
    }

    .modal-link-wrapper {
      display: flex;

      .modal-link {
        margin: 0 auto;
        background: #0f4b9a;
        border-radius: 100px;
        padding: 13px 30px;
        font-weight: 500;
        font-size: 18px;
        color: #ffffff;

        @media screen and (max-width: 400px) {
          padding: 8px 16px;
          font-size: 13px;
        }
      }
    }
  }
}

.btn-wrapper {
  display: flex;
  height: 48px;
  transition: $transition;
  border-top: 1px solid #ededed;

  label.modal-btn {
    display: inline-block;
    cursor: pointer;

    .btn-content span {
      display: inline-block;
      width: 16px;
      height: 16px;
      background: url('#{$s3-url}/img/common/shape_square_state_default_size_big.webp?#{version}') no-repeat center;
      background-size: 100%;
    }

    input[type='checkbox'] {
      display: none;
    }
    input[type='checkbox']:checked + .btn-content span {
      background-image: url('#{$s3-url}/img/common/shape_square_state_check_on_size_big.webp?#{version}');
    }
  }

  .modal-btn {
    width: 100%;
    height: 100%;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    width: 100%;
    margin: 0;

    &:not(:last-child) {
      border-right: 1px solid #ededed;
    }
    &:last-child {
      width: 120px;
    }

    .btn-content {
      height: 100%;
      display: flex;
      align-items: center;
      padding-left: 20px;
      gap: 8px;

      @media screen and (max-width: 400px) {
        gap: 4px;
      }

      img {
        width: 16px;
      }
    }
  }
}
</style>
